module.exports = __webpack_public_path__ + "img/img-3-8.c077d96f.png";